import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const TRAVEL = {
  nickname: 'PRODUCTS.TRAVEL.nickname',
  properties: [
    { name: 'calculatedClientAge', key: 'CLIENT_AGE', group: 'OBJECT_INFO' },
    { name: 'travelType', key: 'TRAVEL_TYPE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_TYPE.PERSONAL', value: 'PERSONAL' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_TYPE.FAMILY', value: 'FAMILY' }
        ]
      }
    },
    { name: 'travelExclusive', key: 'TRAVEL_EXCLUSIVE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'travelDuration', key: 'TRAVEL_DURATION', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_TRAVEL_DURATION.45', value: '45' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_TRAVEL_DURATION.50', value: '50' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_TRAVEL_DURATION.55', value: '55' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_TRAVEL_DURATION.60', value: '60' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_TRAVEL_DURATION.70', value: '70' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_TRAVEL_DURATION.80', value: '80' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_TRAVEL_DURATION.90', value: '90' },
        ]
      },
      customValueConfig: {
        true: {
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_TRAVEL_DURATION.60', value: '60' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_TRAVEL_DURATION.70', value: '70' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_TRAVEL_DURATION.80', value: '80' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_TRAVEL_DURATION.90', value: '90' },
            ]
          }
        },
        false: {
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_TRAVEL_DURATION.45', value: '45' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_TRAVEL_DURATION.50', value: '50' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_TRAVEL_DURATION.55', value: '55' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_TRAVEL_DURATION.60', value: '60' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_TRAVEL_DURATION.70', value: '70' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_TRAVEL_DURATION.80', value: '80' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_TRAVEL_DURATION.90', value: '90' },
            ]
          }
        }
      }
    },
    { name: 'travelDurationType', key: 'TRAVEL_DURATION_TYPE', group: 'OBJECT_INFO' },
    { name: 'productPackage', key: 'PRODUCT_PACKAGE_WTC', group: 'INSURANCE_INFO' },
    { name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO' },
  ],
  icon:'travel'
};
